import BaseSensorExtension from '../base-sensor';
import formatMessage from 'format-message';

class BuzzerActuatorExtension extends BaseSensorExtension {
    constructor (runtime) {
        super(runtime);
    }

    getSensorInfo () {
        return {
            id: 'buzzerActuator',
            name: 'Buzzer',
            color1: '#E91E63',
            color2: '#D81B60',
            color3: '#C2185B',

            blocks: [
                {
                    opcode: 'buzzer_playTone',
                    blockType: 'command',
                    text: formatMessage({id: 'buzzer.blocks.playTone', default: 'play tone on pin [PIN] frequency [FREQ] Hz'}),
                    arguments: {
                        PIN: {
                            type: 'number',
                            defaultValue: '8',
                            menu: 'digitalPinMenu'
                        },
                        FREQ: {
                            type: 'number',
                            defaultValue: '1000'
                        }
                    }
                },
                {
                    opcode: 'buzzer_off',
                    blockType: 'command',
                    text: formatMessage({id: 'buzzer.blocks.turnOff', default: 'turn off tone on pin [PIN]'}),
                    arguments: {
                        PIN: {
                            type: 'number',
                            defaultValue: '8',
                            menu: 'digitalPinMenu'
                        }
                    }
                }
            ],

            menus: {},

            codeTemplates: [
                {
                    opcode: 'buzzer_playTone',
                    type: 'command',
                    arduino: {
                        code: 'tone({{PIN}}, {{FREQ}});',
                        setup: ['pinMode({{PIN}}, OUTPUT);'],
                        includes: []
                    },
                    python: {
                        code: 'buzzer_{{PIN}}.freq({{FREQ}}); buzzer_{{PIN}}.duty_u16(32768)',
                        setup: ['buzzer_{{PIN}} = PWM(Pin({{PIN}}))'],
                        imports: ['from machine import Pin, PWM']
                    }
                },
                {
                    opcode: 'buzzer_off',
                    type: 'command',
                    arduino: {
                        code: 'noTone({{PIN}});',
                        setup: ['pinMode({{PIN}}, OUTPUT);'],
                        includes: []
                    },
                    python: {
                        code: 'buzzer_{{PIN}}.duty_u16(0)',
                        setup: ['buzzer_{{PIN}} = PWM(Pin({{PIN}}))'],
                        imports: ['from machine import Pin, PWM']
                    }
                }
            ]
        };
    }

    buzzer_playTone (args) {
        return Promise.resolve();
    }

    buzzer_off (args) {
        return Promise.resolve();
    }
}

export default BuzzerActuatorExtension;
